export default __webpack_public_path__ + "static/media/smartphone.8a5a7f58.svg";